//Auxiliar component, used to wrap multiple components
const aux = (props) => props.children;
export default aux;